module.exports = __webpack_public_path__ + "static/media/logo-wbs-coding-school.c18f0a1b.svg";